define('v3/Common/Components/SelectionBar/SelectionOverview.Component',[
	'knockout',
	'lodash',
	'text!v3/Common/Components/SelectionBar/SelectionOverview.Component.html',
	'v3/Common/Bindings/SelectionBar.Binding',
	'v3/Common/Bindings/Collapse.Binding',
	'v3/Common/Bindings/SvgIcon.Binding'
],
function (ko, _, htmlString) {
	function validateParams (params) {
		if (!params.items) throw new Error('An items list should be supplied.');
		if (!_.every(params.items(), 'selectionBarOverviewName')) throw new Error('A selectionBarOverviewName should be supplied for every item in the list.');
		if (!_.every(params.items(), 'isSelected')) throw new Error('isSelected should be supplied for every item in the list.');
	}

	function SelectionOverviewViewModel (params) {
		var self = this;
		validateParams(params);

		self.selectionCollapsed = ko.observable(true);
		self.toggleSelection = function () {
			self.selectionCollapsed(!self.selectionCollapsed());
		};

		self.deselect = function (item) {
			item.isSelected(false);
		};

		self.items = params.items;
		self.itemsCount = ko.observable(self.items().length);

		self.itemCountUpdater = ko.computed(function () {
			var currentSelectedItems = self.items().length;
			self.itemsCount(currentSelectedItems);

			if (currentSelectedItems === 0 && !self.selectionCollapsed.peek()) {
				self.selectionCollapsed(true);
			}
		});
	}

	return { viewModel: SelectionOverviewViewModel, template: htmlString };
});
